module.exports = __webpack_public_path__ + "bc85d6f39e59271cedb09ccc2f70c88c.svg";